import React from "react";
import { Route, Routes } from "react-router-dom";
import { SettingsDetails } from "./containers/SettingsDetails";
import { SettingsFeeHistory } from "./containers/SettingsFeeHistory";

export const SuperAdminSettings = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<SettingsDetails />} />
                <Route path="/history" element={<SettingsFeeHistory />} />
            </Routes>
        </>
    );
};
